/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";
import { useState,useEffect } from "react";
import { httpRequest } from "utils/httpRequest";

import {
  Badge,

  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';

const Header = () => {
 const { loading, startLoading, stopLoading } = useLoader()
  const [dashboardData,setDashboardData]=useState(null)


  const getDashboardData=async()=>{
    // startLoading()
     try {
    
                const response = await httpRequest(
                    "admin/dashboardData",
                    "GET",
                    {},
                    {},
                    true,
                    false
                );
                if (response?.code === 200) {
                 
                    setDashboardData(response?.data)
                  
    
                }
    
            } catch (error) {
                console.log(error);
            }finally{
              // stopLoading()
            }
  }


useEffect(()=>{
  getDashboardData()
},[])







  const [data, setData] = useState([
    { id: 1, name: 'John Doe', email: 'john@example.com', status: 'Active', role: 'Admin' },
    { id: 2, name: 'Jane Smith', email: 'jane@example.com', status: 'Inactive', role: 'User' },
    { id: 3, name: 'Mike Johnson', email: 'mike@example.com', status: 'Active', role: 'Editor' },
    { id: 4, name: 'Sarah Wilson', email: 'sarah@example.com', status: 'Active', role: 'User' },
    { id: 5, name: 'Tom Brown', email: 'tom@example.com', status: 'Inactive', role: 'Admin' },
    { id: 6, name: 'Lisa Davis', email: 'lisa@example.com', status: 'Active', role: 'Editor' },
    { id: 7, name: 'Mark Taylor', email: 'mark@example.com', status: 'Inactive', role: 'User' },
  ]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  // Calculate pagination
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = data.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getStatusBadge = (status) => {
    return status === 'Active'
      ? 'badge badge-success'
      : 'badge badge-danger';
  };




  return (
    <>
  <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body addh-header">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Users
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {dashboardData?.totalUsers}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fas fa-users" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      {/* <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> 3.48%
                      </span>{" "} */}
                      {/* <span className="text-nowrap">Since last month</span> */}
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Articles
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{dashboardData?.totalArticles}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fas fa-newspaper" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      {/* <span className="text-danger mr-2">
                        <i className="fas fa-arrow-down" /> 3.48%
                      </span>{" "} */}
                      {/* <span className="text-nowrap">Since last week</span> */}
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Podcast
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{dashboardData?.totalPodcasts}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-purple text-white rounded-circle shadow">
                          <i className="fas fa-podcast" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      {/* <span className="text-warning mr-2">
                        <i className="fas fa-arrow-down" /> 1.10%
                      </span>{" "}
                      <span className="text-nowrap">Since yesterday</span> */}
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Associate SRB
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{dashboardData?.totalAssociates}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-handshake" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      {/* <span className="text-success mr-2">
                        <i className="fas fa-arrow-up" /> 12%
                      </span>{" "}
                      <span className="text-nowrap">Since last month</span> */}
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <div className="col mt-5">
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <h3 className="mb-0">Recent Users</h3>
                  </CardHeader>
                  <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    {/* Table Header */}
                    <div className="container-fluid py-4">
                      <div className="row">
                        <div className="col">
                          <div className="card shadow">
                            {/* Card Header */}
                            <div className="card-header border-0">
                              {/* <h3 className="mb-0">Data Table</h3> */}
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                              <table className="table align-items-center table-flush">
                                <thead className="thead-light">
                                  <tr>
                                    <th scope="col">S.No</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Email</th>

                                    <th scope="col"></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dashboardData?.recentUsers.map((item, index) => (
                                    <tr key={item._id}>
                                      <td>
                                        <span className="mb-0 text-sm font-weight-bold">
                                          {index + 1}
                                        </span>
                                      </td>
                                      <td>
                                        <span className="mb-0 text-sm font-weight-bold">
                                          {item?.firstName}
                                        </span>{" "}
                                        <span className="mb-0 text-sm font-weight-bold">
                                          {item?.lastName}
                                        </span>
                                      </td>

                                      <td>
                                        <span className="text-muted">
                                          {item?.email}
                                        </span>
                                      </td>
                                      {/* <td>
                          <span className={getStatusBadge(item.status)}>
                            {item.status}
                          </span>
                        </td> */}
                                      {/* <td>
                          <span className="text-sm">
                            {item.role}
                          </span>
                        </td> */}
                                      {/* <td className="text-right">
                          <div className="dropdown">
                            <button
                              className="btn btn-sm btn-icon-only text-light"
                              type="button"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              onClick={(e) => {
                                e.preventDefault();
                                console.log('Action clicked for', item.name);
                              }}
                            >
                              <i className="fas fa-ellipsis-v"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                              <button 
                                className="dropdown-item"
                                onClick={(e) => {
                                  e.preventDefault();
                                  console.log('Edit', item.name);
                                }}
                              >
                                Edit
                              </button>
                              <button 
                                className="dropdown-item"
                                onClick={(e) => {
                                  e.preventDefault();
                                  console.log('View', item.name);
                                }}
                              >
                                View Details
                              </button>
                              <button 
                                className="dropdown-item text-danger"
                                onClick={(e) => {
                                  e.preventDefault();
                                  console.log('Delete', item.name);
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </td> */}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            {/* Card Footer with Pagination */}
                            {/* <div className="card-footer py-4">
                              <div className="d-flex justify-content-between align-items-center">
                               
                                <div>
                                  <small className="text-muted">
                                    Showing {startIndex + 1} to {Math.min(endIndex, data.length)} of {data.length} results
                                  </small>
                                </div>

                             
                                <nav aria-label="Table pagination">
                                  <ul className="pagination justify-content-end mb-0">
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                      >
                                        <i className="fas fa-angle-left"></i>
                                        <span className="sr-only">Previous</span>
                                      </button>
                                    </li>

                                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                      <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                        <button
                                          className="page-link"
                                          onClick={() => handlePageChange(page)}
                                        >
                                          {page}
                                          {currentPage === page && <span className="sr-only">(current)</span>}
                                        </button>
                                      </li>
                                    ))}

                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                      <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                      >
                                        <i className="fas fa-angle-right"></i>
                                        <span className="sr-only">Next</span>
                                      </button>
                                    </li>
                                  </ul>
                                </nav>
                              </div>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Pagination Footer */}

                  </div>

                </Card>
              </div>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
